import './styles.scss';

export const Advisors = () => {
  return (
    <p className="c-advisors">
      <span className="c-advisors__label">Co-Advisors:</span> Lilliana Mason and Chryl Laird
    </p>
  )
}